<template>
  <main class="not-found">Ops! 404</main>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>
